import { Button, Chip, MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import PredefinedPeriods from "../../../widgets/CustomDatePicker/PredefinedPeriod";

const FiltersBar = ({
  t,
  pageFilter,
  locations,
  kiosks,
  selectedPeriod,
  handlePeriodChange,
  setSelectedPeriod,
  setpersonalizedDates,
  changePageFilter,
  clearpageFilter,
}) => {
  return (
    <div className="mt-2 flex items-end space-x-4 flex-grow">
      <div className="flex w-1/4 flex-col">
        {t("location_filter")}
        <Select
          size="small"
          variant="outlined"
          className="w-100"
          displayEmpty
          value={pageFilter.emplacement}
          onChange={(e) => changePageFilter("emplacement", e.target.value)}
        >
          <MenuItem value={""} style={{ display: locations && locations.length <= 1 ? "none" : "block" }}>
            {t("all_text")}
          </MenuItem>
          {locations &&
            locations.map((emplacement, index) => (
              <MenuItem
                key={emplacement._id}
                value={emplacement._id}
                selected={locations.length === 1 && index === 0}
              >
                <div className="flex items-center justify-between">
                  <span style={{ marginRight: "10px" }}>{emplacement.location_name}</span>
                </div>
              </MenuItem>
            ))}
        </Select>
      </div>

      <div className="flex flex-col w-1/4">
        {t("kiosk_filter")}
        <Select
          size="small"
          variant="outlined"
          className="w-40"
          displayEmpty
          fullWidth
          value={pageFilter.kiosk}
          onChange={(e) => changePageFilter("kiosk", e.target.value)}
        >
          <MenuItem value={""} style={{ display: kiosks && kiosks.length <= 1 ? "none" : "block" }}>
            {t("all_text")}
          </MenuItem>
          {kiosks &&
            kiosks.map((kiosk, index) => (
              <MenuItem key={kiosk._id} value={kiosk._id} selected={kiosks.length === 1 && index === 0}>
                <div className="flex flex-1 items-center justify-between">
                  <span>{kiosk.name}</span>
                  <div>
                    <Chip
                      color={kiosk.is_active ? "success" : "error"}
                      label={kiosk.is_active ? t("active") : t("in_active")}
                      size="small"
                    />
                  </div>
                </div>
              </MenuItem>
            ))}
        </Select>
      </div>

      <div className="flex flex-col" style={{ width: "200px" }}>
        {t("donation_source_filter", { defaultValue: "Source" })}
        <Select
          size="small"
          variant="outlined"
          displayEmpty
          value={pageFilter.donation_source}
          onChange={(e) => changePageFilter("donation_source", e.target.value)}
        >
          <MenuItem value={""}>
            {t("donation_source_all", { defaultValue: "All" })}
          </MenuItem>
          <MenuItem value={"onsite"}>
            {t("donation_source_onsite", { defaultValue: "Onsite" })}
          </MenuItem>
          <MenuItem value={"online"}>
            {t("donation_source_online", { defaultValue: "Online" })}
          </MenuItem>
        </Select>
      </div>

      <div className="flex flex-col" style={{ width: "200px" }}>
        {t("period")}
        <PredefinedPeriods
          selectedPeriod={selectedPeriod}
          handlePeriodChange={handlePeriodChange}
          setSelectedPeriod={setSelectedPeriod}
          setpersonalizedDates={setpersonalizedDates}
        />
      </div>

      <div className="items-end space-x-4" style={{ marginLeft: "auto" }}>
        <Button color="secondary" onClick={clearpageFilter}>
          {t("clear_filter")}
        </Button>
      </div>
    </div>
  );
};

export default FiltersBar;
